import { IState } from '../model';

export const initialState: IState = {
  completed: false,
  failed: false,
  processing: false,
  notes: [],
  note: null,
  isCreating: false,
  triggerSaveApiInDoc: false,
  payloadForUMCPostDocSave: null,
  currentSelectedAIUMCNotes: [],
};
